export function shuffleArrayInPlace(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}
export function shuffleArrayCopy(array) {
    const copy = array.slice(0);
    shuffleArrayInPlace(copy);
    return copy;
}
export function randomSample(array, count) {
    if (array.length < count)
        return shuffleArrayCopy(array);
    const indices = [];
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        let j = Math.floor(Math.random() * (array.length - i) + i);
        result[i] = array[indices[j] === undefined ? j : indices[j]];
        indices[j] = indices[i] === undefined ? i : indices[i];
    }
    return [...new Set(result)];
}
export function randomElement(array) {
    return array[Math.floor(Math.random() * array.length)];
}
function normalize(input) {
    return input.normalize('NFD').replace(/\W/gu, '').toLowerCase();
}
export async function searchCaseAccentInsensitive(input, options, comparatorValue) {
    const normInput = normalize(input);
    const fullOptions = options || [];
    if (normInput === '') {
        return fullOptions;
    }
    return fullOptions.filter((item) => normalize(comparatorValue(item)).includes(normInput));
}
export function gtag() {
    // @ts-ignore
    window.dataLayer.push(arguments);
}
